
import Accordion from './Accordion';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';



function Airwarmermachinemanufacturesinindian() {



  const cardData =
  {
    keyword: 'Air Warmer Machine Manufacturers in India',
    heading: 'Pharmacle Health Care Private Limited: Air Warmer Machine Manufacturers in India',
    headingDescription: 'Pharmacle Health Care Private Limited is a leading manufacturer of Air Warmer Machines in India, offering advanced thermal care solutions designed to maintain optimal patient body temperature during surgical and critical care procedures. Our state-of-the-art air warmer machines utilize forced-air technology to deliver consistent and controlled heat, effectively preventing hypothermia and enhancing patient safety. Trusted by top hospitals and healthcare facilities across the country, our machines are user-friendly, reliable, and integrate seamlessly into various clinical settings. Choose Pharmacle Health Care for superior air warmer machines that elevate the standard of care and improve clinical outcomes.',

    top: 'Pharmacle Health Care Private Limited – Leading Provider of Forced Air-Warming Systems & Blankets',

  "topPlaces": [
    {
      "title": "Pharmacle Forced-Air Warming System – Advanced Thermal Management",
      "description": "Pharmacle Health Care Private Limited offers the Pharmacle Forced-Air Warming System, designed to prevent hypothermia during surgical procedures. The system features HEPA filtration, dual fan speeds, and adjustable temperature settings, ensuring optimal patient comfort and safety. Its lightweight design and user-friendly interface make it suitable for various clinical environments."
    },
    {
      "title": "Pharmacle Health Care – Patient Air Warmer Machine Manufacturer",
      "description": "Based in India, Pharmacle Health Care manufactures patient air warmer machines that provide efficient thermal management during surgeries. Their systems are designed for uniform heat distribution, enhancing patient safety and recovery. The devices are compatible with a range of warming blankets and are built to meet stringent quality standards."
    },
    {
      "title": "Pharmacle Health Care – Indigenous Warmer Machine Manufacturer",
      "description": "Pharmacle Health Care specializes in manufacturing indigenous warmer machines with features like feather-touch temperature controls and stainless steel construction. Their devices are designed for durability and ease of use, catering to the specific needs of Indian healthcare facilities."
    },
    {
      "title": "Pharmacle Healthcare – Normothermia Patient Warmer",
      "description": "Pharmacle Healthcare offers advanced patient warmers engineered to maintain normothermia during perioperative phases. The devices boast features like HEPA air filtration, adjustable temperature settings, and overheat protection sensors. Ergonomic designs and mobility options make them a versatile choice for hospitals."
    },
    {
      "title": "Pharmacle Medical Supplies – Comprehensive Range of Patient Warmers",
      "description": "Pharmacle Medical Supplies provides a diverse selection of patient warmers, including air warmer blankets and advanced convective warming systems. They offer solutions that cater to various clinical requirements and budgets. Their inventory supports both purchase and rental options to meet healthcare providers’ needs."
    }
  ],

"services": [
    {
        "name": "Air Warmer Machine Manufacturers India",
        "description": "Pharmacle Health Care is one of the top manufacturers of air warmer machines in India, offering advanced solutions for patient temperature management. Our machines use forced air technology to provide consistent and safe body warming during surgeries and medical procedures. Built for reliability and ease of use, our air warmer machines help prevent hypothermia and promote patient recovery across clinical settings."
    },
    {
        "name": "Forced Air Warming Machine India",
        "description": "We offer high-quality forced air warming machines in India, ideal for use in operating rooms, recovery areas, and ICUs. These machines deliver warm air through specially designed blankets, maintaining normothermia and reducing the risk of complications due to temperature loss. Pharmacle Health Care’s devices are trusted by hospitals for their performance, safety, and ease of integration into medical workflows."
    },
    {
        "name": "Surgical Air Heating Equipment",
        "description": "Pharmacle Health Care supplies surgical air heating equipment designed to maintain patient body temperature during operative procedures. These systems utilize controlled warm air to reduce the incidence of hypothermia, ensuring safer and more efficient surgeries. With user-friendly controls and precise temperature settings, they enhance surgical outcomes and patient care."
    },
    {
        "name": "Medical Air Warmer Machine Suppliers",
        "description": "As a trusted supplier of medical air warmer machines, Pharmacle Health Care delivers equipment that plays a critical role in maintaining patient warmth during treatments. Our machines use convective air heating to stabilize body temperature, supporting patients during surgeries, trauma care, and intensive recovery. Built with advanced safety features, they are a dependable choice for modern healthcare environments."
    },
    {
        "name": "Hospital Air Warming Systems",
        "description": "We provide comprehensive hospital air warming systems tailored for use across surgical units, recovery rooms, and ICUs. These systems help maintain a consistent body temperature through forced air circulation, reducing hypothermia risks and improving patient comfort. Pharmacle Health Care’s air warming systems are energy-efficient, safe, and compatible with various warming blankets and accessories."
    },
    {
        "name": "Air-Based Patient Temperature Regulation",
        "description": "Pharmacle Health Care offers air-based patient temperature regulation solutions, using forced air technology to deliver accurate and consistent body warming. These systems are essential for critical surgeries and post-operative care, where thermal regulation is vital. Designed with precision controls and safety mechanisms, our devices ensure optimal patient care throughout the treatment process."
    },
    {
        "name": "Convective Air Heater Devices",
        "description": "Our convective air heater devices are engineered to deliver targeted warming for patients undergoing medical procedures. By circulating heated air through specialized blankets, these devices help prevent hypothermia and maintain thermal stability. Pharmacle Health Care’s systems are widely used in hospitals for their ease of use, durability, and clinical effectiveness."
    },
    {
        "name": "Patient Heating Machines India",
        "description": "Pharmacle Health Care manufactures and supplies patient heating machines across India, providing essential support for maintaining body temperature during medical procedures. These machines are designed to offer consistent and safe warming using convective air systems. They play a critical role in surgical care, trauma recovery, and intensive treatment settings, enhancing patient safety and comfort."
    }
],
"tableData": [
    ["- Air Warmer Machine Manufacturers India", "- Forced Air Warming Machine India"],
    ["- Surgical Air Heating Equipment", "- Medical Air Warmer Machine Suppliers"],
    ["- Hospital Air Warming Systems", "- Air-Based Patient Temperature Regulation"],
    ["- Convective Air Heater Devices", "- Patient Heating Machines India"]
],

"whychoose": [
    {
        "WhyChooseheading": "Advanced and Reliable Warming Technology",
        "WhyChoosedescription": "As leading Air Warmer Machine Manufacturers in India, we provide state-of-the-art technology that ensures precise and controlled warmth for patients during medical procedures. Our air warmer machines effectively maintain body temperature, preventing hypothermia and enhancing patient safety."
    },
    {
        "WhyChooseheading": "Comprehensive Patient Warming Solutions",
        "WhyChoosedescription": "Our Air Warmer Machines are part of a comprehensive range of patient warming solutions designed to meet the needs of hospitals and clinics across India. From operating rooms to recovery areas, our systems ensure patients remain comfortable and safe during treatment."
    },
    {
        "WhyChooseheading": "High-Quality, Durable Equipment",
        "WhyChoosedescription": "Manufactured to the highest quality standards, our Air Warmer Machines are durable, reliable, and built for long-term use in demanding healthcare environments. These machines are rigorously tested for safety and performance, providing healthcare providers in India with dependable solutions for patient care."
    },
    {
        "WhyChooseheading": "Safe and Comfortable for Patients",
        "WhyChoosedescription": "Patient safety and comfort are our top priorities. Our Air Warmer Machines are designed to provide gentle and controlled warmth to prevent temperature-related complications during surgeries and medical treatments, ensuring the best possible care for patients."
    },
    {
        "WhyChooseheading": "Flexible Solutions for Healthcare Providers",
        "WhyChoosedescription": "Our Air Warmer Machines in India are versatile and adaptable to various healthcare settings, including hospitals, operating rooms, and recovery units. We work closely with healthcare providers to ensure our systems meet the unique needs of each facility, improving patient outcomes."
    },
    {
        "WhyChooseheading": "Easy Integration with Existing Systems",
        "WhyChoosedescription": "Designed for seamless integration, our Air Warmer Machines can be easily incorporated into existing medical systems without disrupting ongoing procedures. This allows healthcare professionals to maintain patient comfort and safety while enhancing operational efficiency."
    },
    {
        "WhyChooseheading": "Expert Consultation and Support",
        "WhyChoosedescription": "We provide expert consultation services to healthcare facilities in India, helping them select the right Air Warmer Machines for their needs. Our team also offers ongoing support and maintenance to ensure the machines continue to perform optimally."
    },
    {
        "WhyChooseheading": "Commitment to Patient Safety and Comfort",
        "WhyChoosedescription": "At Pharmacle Health Care Private Limited, we are committed to patient safety and comfort. Our Air Warmer Machines are designed to ensure that patients across India receive the highest standard of care during medical procedures, preventing temperature-related risks and promoting recovery."
    }
]





















  }

  const faqData = [
    {
      question: "Who are the leading Air Warmer Machine manufacturers in India?",
      answer: "Pharmacle Health Care Private Limited is one of the leading manufacturers of Air Warmer Machines in India. They offer advanced warming systems that help regulate patient body temperature during surgical procedures and critical care."
    },
    {
      question: "What is an Air Warmer Machine used for?",
      answer: "An Air Warmer Machine is used to prevent hypothermia during surgeries and medical procedures. It circulates warm air through a blanket or pad placed on the patient’s body, ensuring that their body temperature remains within a safe range."
    },
    {
      question: "How does an Air Warmer Machine work?",
      answer: "The Air Warmer Machine works by using a blower to circulate warm, filtered air through a warming blanket or pad that is placed on the patient. This helps maintain the patient’s body temperature during surgical operations or critical care situations."
    },
    {
      question: "Are Air Warmer Machines available across India?",
      answer: "Yes, manufacturers like Pharmacle Health Care offer Air Warmer Machines across India. These systems are available for purchase and installation in hospitals and healthcare facilities throughout the country."
    },
    {
      question: "Does Pharmacle Health Care provide support for Air Warmer Machines?",
      answer: "Yes, Pharmacle Health Care provides complete support, including installation, training, and maintenance services to ensure optimal performance and safety of their Air Warmer Machines."
    }
  ];
  
  const testimonialsData = [
    {
      text: "The Air Warmer Machines from Pharmacle Health Care have been a crucial part of our surgical practices. They keep our patients comfortable and prevent hypothermia during long procedures.",
      name: "Dr. Ramesh Kumar, MediCare Hospital"
    },
    {
      text: "Pharmacle Health Care’s Air Warmer Machines are efficient and reliable. We’ve seen improved patient outcomes, especially during major surgeries where maintaining body temperature is critical.",
      name: "Dr. Anjali Mehta, City Clinic"
    }
  ];
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  

  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  























  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 8956322311",
      "+91 8421773700",

    ],
    email: "info@wallabieswarmcares.com"
  };


const Images = [
  {
    place: "/images/keyword/1.jpg",
    text: "Patient Forced Air Warming System in Pune",
    link: "/Patient-Forced-Air-Warming-System-in-Pune",
  },
  {
    place: "/images/keyword/2.jpg",
    text: "Patient Forced Air Warming Blankets in Delhi",
    link: "/Patient-Forced-Air-Warming-Blankets-in-Delhi",
  },
  {
    place: "/images/keyword/3.jpg",
    text: "Patient Forced Air Warmer in Mumbai",
    link: "/Patient-Forced-Air-Warmer-in-Mumbai",
  },
  {
    place: "/images/keyword/5.jpg",
    text: "Patient Warming Systems in Chennai",
    link: "/Patient-Warming-Systems-in-Chennai",
  },
  {
    place: "/images/keyword/6.jpg",
    text: "Patient Warmer in Bengaluru",
    link: "/Patient-Warmer-in-Bengaluru",
  },
  {
    place: "/images/keyword/7.jpg",
    text: "Normothermia Equipment in Hyderabad",
    link: "/Normothermia-Equipment-in-Hyderabad",
  },
  {
    place: "/images/keyword/8.jpg",
    text: "Patient Thermoregulation System in Ahmedabad",
    link: "/Patient-Thermoregulation-System-in-Ahmedabad",
  },
  {
    place: "/images/keyword/9.jpg",
    text: "Patient Warming Devices in Kolkata",
    link: "/Patient-Warming-Devices-in-Kolkata",
  },
  {
    place: "/images/keyword/10.jpg",
    text: "Patient Warming Blankets in Jaipur",
    link: "/Patient-Warming-Blankets-in-Jaipur",
  },
  {
    place: "/images/keyword/12.jpg",
    text: "Patient Forced Air Warming System in Surat",
    link: "/Patient-Forced-Air-Warming-System-in-Surat",
  },
  {
    place: "/images/keyword/13.jpg",
    text: "Forced Air Warming Blankets in Coimbatore",
    link: "/Forced-Air-Warming-Blankets-in-Coimbatore",
  },
  {
    place: "/images/keyword/14.jpg",
    text: "Patient Warming Blankets in Lucknow",
    link: "/Patient-Warming-Blankets-in-Lucknow",
  },
  {
    place: "/images/keyword/15.jpg",
    text: "Patient Forced Air Warmer in Chandigarh",
    link: "/Patient-Forced-Air-Warmer-in-Chandigarh",
  },
  {
    place: "/images/keyword/17.jpg",
    text: "Thermoregulation Systems in Indore",
    link: "/Thermoregulation-Systems-in-Indore",
  },
  {
    place: "/images/keyword/18.jpg",
    text: "Patient Warming Systems in Patna",
    link: "/Patient-Warming-Systems-in-Patna",
  },
  {
    place: "/images/keyword/19.jpg",
    text: "Patient Forced Air Warming System in Hyderabad",
    link: "/Patient-Forced-Air-Warming-System-in-Hyderabad",
  },
  {
    place: "/images/keyword/20.jpg",
    text: "Patient Forced Air Warming Blankets in Delhi NCR",
    link: "/Patient-Forced-Air-Warming-Blankets-in-Delhi-NCR",
  },
  {
    place: "/images/keyword/21.jpg",
    text: "Forced Air Warming System in Noida",
    link: "/Forced-Air-Warming-System-in-Noida",
  },
  {
    place: "/images/keyword/22.jpg",
    text: "Patient Warming Devices in Bhopal",
    link: "/Patient-Warming-Devices-in-Bhopal",
  },
  {
    place: "/images/keyword/23.jpg",
    text: "Patient Warming Blankets in Kochi",
    link: "/Patient-Warming-Blankets-in-Kochi",
  },
  {
    place: "/images/keyword/24.jpg",
    text: "Patient Warming System in Pune",
    link: "/Patient-Warming-System-in-Pune",
  },
  {
    place: "/images/keyword/25.jpg",
    text: "Forced Air Warming Blankets in Bengaluru",
    link: "/Forced-Air-Warming-Blankets-in-Bengaluru",
  },
  {
    place: "/images/keyword/26.jpg",
    text: "Patient Warming Devices in Chennai",
    link: "/Patient-Warming-Devices-in-Chennai",
  },
  {
    place: "/images/keyword/27.jpg",
    text: "Patient Thermoregulation System in Surat",
    link: "/Patient-Thermoregulation-System-in-Surat",
  },
];


  const images = [
    { src: "/images/keyword/1.jpg", alt: "Image 1" },
    { src: "/images/keyword/5.jpg", alt: "Image 1" },
    { src: "/images/keyword/2.jpg", alt: "Image 1" },
    { src: "/images/keyword/18.jpg", alt: "Image 1" },
    { src: "/images/keyword/4.jpg", alt: "Image 1" },
    { src: "/images/keyword/7.jpg", alt: "Image 1" },
    { src: "/images/keyword/8.jpg", alt: "Image 1" },
    { src: "/images/keyword/19.jpg", alt: "Image 1" },
    { src: "/images/keyword/6.jpg", alt: "Image 1" },

  ];


  const jsonData = {
    "@context": "https://schema.org",
    "@type": "Product",
    "name": "Air Warmer Machine Manufacturers in India",
    "description": "Leading Air Warmer Machine Manufacturers in India supplying forced air heating equipment for surgical use, patient temperature regulation, and hospital-grade convective air heater systems.",
    "aggregateRating": {
      "@type": "AggregateRating",
      "bestRating": "5",
      "worstRating": "1",
      "ratingValue": "4.8",
      "ratingCount": "1093"
    }
  };
  
  
  
  

  

  return (
    <div>
<Helmet>
    <title>Air Warmer Machine Manufacturers in India | Contact: +91 8956322311</title>
    <meta
      name="description"
      content="Find reliable Air Warmer Machine Manufacturers in India. We offer forced air warming machines, surgical air heating systems, and hospital patient temperature regulation equipment. Call +91 8956322311."
    />
    <meta
      name="keywords"
      content="Air Warmer Machine Manufacturers India, Forced Air Warming Machine India, Surgical Air Heating Equipment, Medical Air Warmer Machine Suppliers, Hospital Air Warming Systems, Air-Based Patient Temperature Regulation, Convective Air Heater Devices, Patient Heating Machines India"
    />
    <script type="application/ld+json">
      {JSON.stringify(jsonData)}
    </script>
  </Helmet>
  
      <div className="breadcrumbs overlay">
        <div className="container">
          <div className="bread-inner">
            <div className="row">
              <div className="col-12">
                <h2>{cardData.keyword}</h2>
              </div>
            </div>
          </div>
        </div>
      </div>



      <section>
        <div className="container-fluid" >
          <div className="row container-fluid pt-5">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/56.jpg' alt='img' />
              <h3 className="py-1 pt-4"
                style={{
                  color: '#1A76D1', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3>

              <p className='fw-bold lead text-dark'>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3 text-dark'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            

              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>
              <div>
                <h3 className='Colo'>FAQs {cardData.keyword} for  Pharmacle Health Care Private Limited</h3>
              
                <Accordion data={faqData} />
              </div>
              <div className='py-3'>
            
                <TestimonialKeyword testimonials={testimonialsData} />


              </div>

              <div className='pb-5'>

                <div className="contact-box Borderr ">
                  <h3>{contactData.heading}</h3>
                  <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                  <div className="contact-details ">
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold d-inline "><p className='d-inline'><strong className='darkcolor d-inline'>Mobile No:</strong></p>
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className='darkcolor'>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4'>
              {Images.map((e) => {
                return (
                  <div className="box1">
                    <a href={e.link} className="d-flex justify-content-around align-items-center">
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        <a href={e.link} className='px-3'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })}



              <div className="gallery-container">
                <h2 className="gallery-title darkcolor">Our Gallery</h2>
                <div className="row">
                  {images.map((image, index) => (
                    <div className="gallery-item col-md-4" key={index}>
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="gallery-image"

                      />
                    </div>
                  ))}

                </div>
              </div>

              <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px solid #1A76D1',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3  fw-bold text-bluee text-center">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3 rounded">
                    <div className="Small_border rounded  text-center  " style={{ backgroundColor: '#1A76D1' }}>
                      <div>
                        <h4 className=" lead fw-semibold whitt ">Phone Numbers</h4>
                      </div>

                      <div className=''>
                        <a href="tel:+918956322311" className="d-block  text-white">
                          <i className="fas fa-phone darkcolorrr colored me-2"></i>+91 8956322311
                        </a>
                        <a href="tel:+918421773700" className="d-block  text-white">
                          <i className="fas fa-phone darkcolorrr colored me-2"></i>+91 8421773700
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">

                      <div className='rounded ' style={{ backgroundColor: '#1A76D1' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:info@wallabieswarmcares.com" className=" text-white d-block">
                          <i className="fas fa-envelope darkcolorrr"></i> info@wallabieswarmcares.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">

                      <div className='rounded ' style={{ backgroundColor: '#1A76D1' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className=" text-white ">
                          <i className="fas fa-map-marker-alt darkcolorrr"></i>  Pharmacle Health Care Private Limited <br />
                          Gat No. 1251/2/3/1252 Plot No. 28, Block Sector, Weikfield Industrial Estate, Pune - Nagar Road, Sanaswadi, Pune, Maharashtra, 412208


                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Airwarmermachinemanufacturesinindian;